import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import CreditScoreIcon from '../../../utils/images/credit-score-icon';
import ApprovedIcon from '../../../utils/images/approved-icon';
import MaximizeRewardsIcon from '../../../utils/images/maximize-rewards-icon';

// Taken from the CardFinder's Branded LP Figma
const BACKGROUND_COLOR = '#DEEFFF';

type CardProps = {
  iconComponent: ReactNode;
  headline: string;
  description: string;
};

const Card = ({ iconComponent, headline, description }: CardProps) => (
  <Box
    minWidth="22rem"
    height="12rem"
    flex={1}
    bgcolor="common.white"
    boxShadow={{ xs: 3, xl: 0 }}
  >
    <Box
      paddingX={3}
      paddingTop={3.5}
      paddingBottom={4.75}
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      gap={1.5}
    >
      <Box color="blue.main" height="28px">
        {iconComponent}
      </Box>
      <Typography variant="textBold" fontSize={20}>
        {headline}
      </Typography>
      <Typography>{description}</Typography>
    </Box>
  </Box>
);

export const InsightsSection = () => (
  <Box bgcolor={BACKGROUND_COLOR}>
    <Box
      paddingX={{ xs: 0, xl: 11 }}
      paddingY={11}
      width={{ xs: '80%', xl: '75%' }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={4.5}
      margin="0 auto"
    >
      <Typography
        variant="bodyLargeBold"
        color="blue.dark"
        textAlign="center"
        fontSize={24}
      >
        Why use NerdWallet’s CardFinder?
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        gap={2.56}
      >
        <Card
          iconComponent={<CreditScoreIcon />}
          headline="It won’t affect your credit score"
          description="There’s no hard credit check required to see your results."
        />
        <Card
          iconComponent={<ApprovedIcon />}
          headline="Personalized results in minutes"
          description="We only ask the questions we need to recommend cards that fit your goals. "
        />
        <Card
          iconComponent={<MaximizeRewardsIcon />}
          headline="Tap into our nerdy knowledge"
          description="Get a Nerd’s eye view with reviews and helpful info for each card we recommend."
        />
      </Box>
    </Box>
  </Box>
);
